<template>
  <div class="profitability-analysis-container">
    <div class="tab-header">
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'allInvestment' }"
        @click="activeTab = 'allInvestment'"
      >
        全部投资现金流量
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'capital' }"
        @click="activeTab = 'capital'"
      >
        资本金现金流量
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'financialPlan' }"
        @click="activeTab = 'financialPlan'"
      >
        财务计划现金流量
      </button>
    </div>

    <div class="tab-content">
      <AllInvestmentCashFlow
        v-if="activeTab === 'allInvestment'"
        ref="allInvestmentRef"
        @save="handleSave"
      />
      <CapitalCashFlow
        v-if="activeTab === 'capital'"
        ref="capitalRef"
        @save="handleSave"
      />
      <FinancialPlanCashFlow
        v-if="activeTab === 'financialPlan'"
        ref="financialPlanRef"
        @save="handleSave"
      />
    </div>
  </div>
</template>

<script>
import AllInvestmentCashFlow from "./AllInvestmentCashFlow.vue";
import CapitalCashFlow from "./CapitalCashFlow.vue";
import FinancialPlanCashFlow from "./FinancialPlanCashFlow.vue";

export default {
  name: "ProfitabilityAnalysis",
  components: {
    AllInvestmentCashFlow,
    CapitalCashFlow,
    FinancialPlanCashFlow,
  },
  data() {
    return {
      activeTab: "allInvestment",
    };
  },
  methods: {
    handleSave(componentData) {
      this.saveToVuex();
      this.$toast.success("保存成功");
    },
    saveToVuex() {
      const currentData = this.$store.state.projectData || {};
      const existingInvestmentEstimate = currentData.investmentEstimate || {};
      const existingProfitabilityData =
        existingInvestmentEstimate.profitabilityData || {};

      const newProfitabilityData = {
        ...existingProfitabilityData,
        allInvestmentCashFlowData:
          this.$refs.allInvestmentRef?.getFormData() || {},
        capitalCashFlowData: this.$refs.capitalRef?.getFormData() || {},
        financialPlanCashFlowData:
          this.$refs.financialPlanRef?.getFormData() || {},
      };

      const newInvestmentEstimate = {
        ...existingInvestmentEstimate,
        profitabilityData: newProfitabilityData,
      };

      // 只更新投资估算数据，不覆盖其他组件的数据
      const updatedData = {
        ...currentData,
        investmentEstimate: newInvestmentEstimate,
      };

      this.$store.commit("setProjectData", updatedData);
      this.$store.commit("setIsProjectSaved", false);
    },
  },
};
</script>

<style scoped>
.profitability-analysis-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.tab-header {
  display: flex;
  gap: 0;
  margin-bottom: 20px;
  border-bottom: 2px solid #409eff;
}

.tab-btn {
  padding: 10px 24px;
  border: none;
  background-color: #f5f7fa;
  color: #606266;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 4px 4px 0 0;
  margin-right: 2px;
}

.tab-btn:hover {
  color: #409eff;
  background-color: #ecf5ff;
}

.tab-btn.active {
  background-color: #409eff;
  color: #fff;
}

.tab-content {
  flex: 1;
  overflow: auto;
}
</style>
